import { TimeOffPolicy } from '@/features/time-off/time-off.def.ts'

export const routes = {
  login: '/login',
  logout: '/logout',
  documentation: '/documentation',
  documentAutofillList: '/hc-admin/document-autofill',
  documentAutofill: (type: string, country: string, templateName: string) => `/hc-admin/document-autofill/${country}/${type}/${templateName}`,
  hcChecklists: '/hc-admin/checklist',
  hcChecklistConfig: '/hc-admin/checklist/config',
  hcChecklistConfigNew: '/hc-admin/checklist/config/new',
  hcChecklistConfigEdit: (id: number) => `/hc-admin/checklist/config/${id}/edit`,
  employeeData: (employeeId?: string) => `/hc-admin/employee-data${employeeId ? `/${employeeId}` : ''}`,
  employeeDirectory: '/hc-admin/employee-data',
  departmentConfig: '/hc-admin/employee-data/departments',
  teamConfig: '/hc-admin/employee-data/teams',
  headcountReports: '/hc-admin/headcount',
  headcountCharts: '/hc-admin/headcount/charts',
  staffCost: '/hc-admin/staff-cost',
  appraisalEventList: '/hc-admin/appraisal/events',
  appraisalGoalList: '/hc-admin/appraisal/goals',
  appraisalEvent: (eventId: number) => `/hc-admin/appraisal/events/${eventId}`,
  appraisalGoal: (eventId: number) => `/hc-admin/appraisal/goals/${eventId}`,
  createAppraisalEvent: '/hc-admin/appraisal/events/create',
  createAppraisalGoal: '/hc-admin/appraisal/goals/create',
  offboardingList: '/hc-admin/offboarding',
  offboardingDetails: (offboardingId: number) => `/hc-admin/offboarding/${offboardingId}`,
  orgChart: '/hc-admin/organization-chart',
  portalConfig: '/hc-admin/portal-configuration',
  timeOffConfig: '/hc-admin/time-off',
  timeOffReports: '/hc-admin/time-off/reports',
  employeeTimeOff: (employeeId?: string) => `/hc-admin/time-off/employee${employeeId ? `?employeeId=${employeeId}` : ''}`,
  timeOffPolicyDetails: ({
    id,
    country,
  }: TimeOffPolicy) => `/hc-admin/time-off?country=${country}&tab=types&policy=${id}`,
  onboarding: (recordId?: string) => `/hc-admin/onboarding${recordId ? `/${recordId}` : ''}`,
}

export const userRoutes = {
  termSheets: '/document-autofill/term-sheets',
  appraisalResponseList: '/appraisal',
  employeeDirectory: '/employee-profile',
  employeeProfile: (employeeId: string) => `/employee-profile/${employeeId}`,
  appraisalResponse: (responseId: number) => `/appraisal/responses/${responseId}`,
  userChecklists: (checklistId?: number) => `/checklist${checklistId ? `/${checklistId}` : ''}`,
  rewardExercise: (year?: number) => `/reward-exercise${year ? `/${year}` : ''}`,
  myTimeOff: '/time-off',
  timeOffApproval: '/time-off/approval',
  timeOffCalendar: '/time-off/calendar',
  overtimeList: '/overtime',
  overtime: (overtimeId?: number) => `/overtime/${overtimeId}`,
  probationList: '/probation',
  probation: (recordId?: number) => `/probation${recordId ? `/${recordId}` : ''}`,
  promotionList: '/promotion',
  promotion: (nominationId?: number) => `/promotion${nominationId ? `/${nominationId}` : ''}`,
}